<!--
 * @Author: shijian.chen
 * @Date: 2021-11-09 16:52:12
 * @LastEditTime: 2023-01-10 15:09:10
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @Description: 领克广告
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/ftms/index.vue
-->
<template>
  <div id="faw202212">
    <div class="appointBox">
      <appoint></appoint>
    </div>
    <img src="https://source.qunarzz.com/site/images/wns/20230110-shijianchen-faw-2.jpg" alt="">
    <img src="https://source.qunarzz.com/site/images/wns/20230110-shijianchen-faw-3.jpg" alt="">
    <img src="https://source.qunarzz.com/site/images/wns/20230110-shijianchen-faw-4.jpg" alt="">
    <img src="https://source.qunarzz.com/site/images/wns/20230110-shijianchen-faw-5.jpg" alt="">
    <img src="https://source.qunarzz.com/site/images/wns/20230110-shijianchen-faw-6.jpg" alt="">
  </div>
</template>
<script>
import appoint from "./components/appoint.vue";
import lineComp from "./components/line.vue";
import videoComp from "./components/video.vue";
export default {
  components: {
    appoint,
    lineComp,
    videoComp,
  },
  data() {
    return {
      activeIndex: 0,
      showSwiper: true,
      imgList1: [
        "https://source.qunarzz.com/site/images/wns/20220407_audi_6.jpg",
        "https://source.qunarzz.com/site/images/wns/20220407_audi_8.png",
      ],
      tabs: ["颜值担当", "空间进阶", "安全进阶", "动力进阶", "智联进阶"],
      videoList: [
        {
          src: "https://source.qunarzz.com/site/images/wns/20220408_video_1.mp4",
          poster:
            "https://source.qunarzz.com/site/images/wns/20220408_poster_1.png",
        },
        {
          src: "https://source.qunarzz.com/site/images/wns/20220408_video_2.mp4",
          poster:
            "https://source.qunarzz.com/site/images/wns/20220408_poster_2.png",
        },
        {
          src: "https://source.qunarzz.com/site/images/wns/20220408_video_3.mp4",
          poster:
            "https://source.qunarzz.com/site/images/wns/20220408_poster_3.png",
        },
        {
          src: "https://source.qunarzz.com/site/images/wns/20220408_video_4.mp4",
          poster:
            "https://source.qunarzz.com/site/images/wns/20220408_poster_4.png",
        },
        {
          src: "https://source.qunarzz.com/site/images/wns/20220408_video_6.mp4",
          poster:
            "https://source.qunarzz.com/site/images/wns/20220408_poster_5.png",
        },
        {
          src: "https://source.qunarzz.com/site/images/wns/20220408_video_5.mp4",
          poster:
            "https://source.qunarzz.com/site/images/wns/20220408_poster_6.png",
        },
      ],
      imgs: [
        [
          {
            title: "电动美学设计",
            src: "https://source.qunarzz.com/site/images/wns/20220408_v1_1.png",
          },
          {
            title: "智能个性灯组",
            src: "https://source.qunarzz.com/site/images/wns/20220408_v1_2.png",
          },
          {
            title: "21”Audi Sport RS 轮毂",
            src: "https://source.qunarzz.com/site/images/wns/20220408_v1_3.png",
          },
          {
            title: "迎宾光束",
            src: "https://source.qunarzz.com/site/images/wns/20220408_v1_4.png",
          },
        ],
        [
          {
            title: "数字虚拟座舱",
            src: "https://source.qunarzz.com/site/images/wns/20220408_v2_1.png",
          },
          {
            title: "巨幕全景天窗",
            src: "https://source.qunarzz.com/site/images/wns/20220408_v2_2.png",
          },
          {
            title: "B&O环绕音响",
            src: "https://source.qunarzz.com/site/images/wns/20220408_v2_3.png",
          },
          {
            title: "AR HUD",
            src: "https://source.qunarzz.com/site/images/wns/20220408_v2_4.png",
          },
        ],
        [
          {
            title: "纯电平台",
            src: "https://source.qunarzz.com/site/images/wns/20220408_v3_1.png",
          },
          {
            title: "quattro 电动四驱系统",
            src: "https://source.qunarzz.com/site/images/wns/20220408_v3_2.png",
          },
          {
            title: "Audi Pro 领航套装",
            src: "https://source.qunarzz.com/site/images/wns/20220408_v3_3.png",
          },
        ],
      ],
      beauty: [
        "https://source.qunarzz.com/site/images/wns/20220408_v4_1.png",
        "https://source.qunarzz.com/site/images/wns/20220408_v4_2.png",
        "https://source.qunarzz.com/site/images/wns/20220408_v4_3.png",
      ],
      swipervideo: null,
    };
  },
  swiper2: null,
  swiper1: null,
  name: "app",
  mounted() {
    this.initSwiper();
    let self = this;
    this.swipervideo = new Swiper("#audi .swipervideo-container", {
      autoplay: {
        delay: 3000, //1秒切换一次
      },
      pagination: {
        el: "#audi .swipervideo-container .swiper-pagination",
      },
      on: {
        slideChange() {
          self.videoList.forEach((item, index) => {
            if (index != this.realIndex) {
              self.$refs["video" + index][0].pause();
            }
          });
        },
        resize: function () {
          //窗口变化了
        },
      },
      // navigation: {
      //   nextEl: ".swiper-button-next",
      //   prevEl: ".swiper-button-prev",
      // },
    });
    new Swiper("#audi .swiper1-container", {
      loop:true,
      autoplay: {
        delay: 3000, //1秒切换一次
      },
      pagination: {
        el: "#audi .swiper1-container .swiper-pagination",
      },
      // navigation: {
      //   nextEl: ".swiper-button-next",
      //   prevEl: ".swiper-button-prev",
      // },
    });
    new Swiper("#audi .swipebeauty-container", {
      loop:true,
      autoplay: {
        delay: 3000, //1秒切换一次
      },
      pagination:{
        el:"#audi .swipebeauty-container .swiper-pagination"
      }
      // navigation: {
      //   nextEl: ".swiper-button-next",
      //   prevEl: ".swiper-button-prev",
      // },
    });
    this.imgs.forEach((item, index) => {
      new Swiper("#audi .swiper" + (index + 2) + "-container", {
        autoplay: {
          delay: 3000, //1秒切换一次
        },
        thumbs: {
          swiper: new Swiper(
            "#audi .swiper" + (index + 2) + "-thumbs-container",
            {
              slidesPerView: item.length,
              freeMode: true,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,
              observer: true, //修改swiper自己或子元素时，自动初始化swiper默认为false
              observeParents: true, //修改swiper的父元素时，自动初始化swiper
            }
          ),
        },
      });
    });
  },
  methods: {
    calcSize(index) {
      return document.querySelectorAll(".tab")[index]
        ? document.querySelectorAll(".tab")[index].offsetTop -
            (8 * window.innerWidth) / 375
        : 0;
    },
    playing() {
      this.swipervideo.autoplay.stop();
    },
    initSwiper() {
      this.$nextTick(() => {
        this.swiper2 = new Swiper("#frontlander .swiper2", {
          slidesPerView: 3,
          freeMode: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          observer: true, //修改swiper自己或子元素时，自动初始化swiper默认为false
          observeParents: true, //修改swiper的父元素时，自动初始化swiper
        });
        this.swiper1 = new Swiper("#frontlander .swiper1", {
          autoplay: {
            delay: 3000, //1秒切换一次
          },
          spaceBetween: 5,
          loop: false,
          initialSlide: 0,
          loopedSlides: 5, //looped slides should be the same
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          thumbs: {
            swiper: this.swiper2,
          },
        });
      });
    },
    setActive(index) {
      this.activeIndex = index;
      this.showSwiper = false;
      let timer = setTimeout(() => {
        clearTimeout(timer);
        this.showSwiper = true;
        this.initSwiper();
      }, 0);
    },
  },
};
</script>
<style lang='less' scoped='true'>
@font-face {
  font-family: "DFPKingGothicGB";
  src: url("./20220408_font.ttf");
}
img {
  display: block;
}
#audi {
  font-family: "DFPKingGothicGB";
  /deep/ .swiper-pagination-bullet {
    opacity: 0.3;
    width: 10px;
    height: 3px;
    background-color: #fff;
    border-radius: 2px;
  }
  /deep/ .swiper-pagination-bullet-active {
    background-color: #fff;
    width: 24px;
    height: 3px;
    opacity: 1;
  }
}
.appointBox {
  box-sizing: border-box;
  background: url(https://source.qunarzz.com/site/images/wns/20230110-shijianchen-faw-1.jpg) no-repeat;
  background-size: 100% auto;
  height: 870px;
}
.swiper1-container{
  height: 810px;
}
.swipervideo-container {
  background-color: #000;
  .swiper-wrapper{
    padding-bottom: 30px;
  }
}
.swiper-container {
  position: relative;
}
.title {
  background-color: #000;
  height: 90px;
  display: flex;
  align-items: center;
  color: #fff;
  justify-content: center;
  font-size: 21px;
  font-family: "DFPKingGothicGB";
}
.thumbs {
  font-size: 9px;
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  .swiper-slide {
    opacity: 0.5;
    height: 33px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /deep/ .swiper-slide-thumb-active {
    opacity: 1;
  }
}
.swipebeauty-container{
  position: relative;
}
</style>